module.exports = __webpack_public_path__ + "img/fifth-section.e7ac683a.webp";